module.exports = __webpack_public_path__ + "src/components/Trust/icons/correct.png?b91ee3f5";


//////////////////
// WEBPACK FOOTER
// ./src/components/Trust/icons/correct.png
// module id = 3375
// module chunks = 8